import type { AgencyListTab } from '@saaga/shared/interfaces/agencies.interface'

export const PRO_ONLY_TAB_LIST: AgencyListTab[] = []

const PRO_ONLY_TAB_SET = new Set<AgencyListTab>(PRO_ONLY_TAB_LIST)

/**
 * Checks whether a given agency tab requires a Pro subscription.
 */
export const isProOnlyTab = (tab: AgencyListTab): boolean => PRO_ONLY_TAB_SET.has(tab)
